import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import './NotFound.scss';
import logo from '../../assets/images/logo.png';

interface NotFoundProps {
  error?: boolean
}

export default function NotFound({ error = false }: NotFoundProps) {
  const { t } = useTranslation('common');
  const history = useHistory();

  const onButtonClick = () => {
    history.push('/');

    if (error) {
      sessionStorage.clear();
      localStorage.clear();
      location.reload();
    }
  };

  return (
    <div className="not-found">
      <Helmet>
        <title>BetXchange - Not Found</title>
      </Helmet>
      <Link to="/">
        <img className="not-found__logo" src={ logo } alt="Logo" />
      </Link>
      <div className="not-found__container">
        { !error && <h1 className="not-found__title">404</h1> }
        <p className="not-found__info">{ !error ? t('404.info') : t('404.error') }</p>
        <button onClick={ onButtonClick } className="not-found__btn">{ t('404.continue') }</button>
      </div>
    </div>
  );
}
